import { createSlice } from '@reduxjs/toolkit';

/**
 * Estado global para ventas con crédito fiscal.
 */
interface CreditFiscalSaleState {
  showAddProductModal: boolean;
  showEditProductModal: boolean;
}

const initialState: CreditFiscalSaleState = {
  showAddProductModal: false,
  showEditProductModal: false,
};

const creditFiscalSaleSlice = createSlice({
  name: 'creditFiscalSale',
  initialState,
  reducers: {
    /**
     * Abre el modal para agregar un nuevo producto.
     */
    openAddProductModal(state) {
      state.showAddProductModal = true;
    },

    /**
     * Cierra el modal de agregar producto.
     */
    closeAddProductModal(state) {
      state.showAddProductModal = false;
    },

    /**
     * Abre el modal de edición de producto.
     */
    openEditProductModal(state) {
      state.showEditProductModal = true;
    },

    /**
     * Cierra el modal de edición de producto.
     */
    closeEditProductModal(state) {
      state.showEditProductModal = false;
    },
  },
});

export const {
  openAddProductModal,
  closeAddProductModal,
  openEditProductModal,
  closeEditProductModal,
} = creditFiscalSaleSlice.actions;

export default creditFiscalSaleSlice.reducer;
